<template>
  <span :class="item.fieldGroupShow ? 'group-field' : ''">
    <template v-if="item.textBoxType === 'input'">
      <!-- v-model="F_Data[item.conditonKey]" -->
      <el-input
        v-if="item.textBoxType === 'input'"
        v-model="item.conditonVal"
        placeholder="请输入"
        clearable
      ></el-input>
      <slot></slot>
    </template>
    <template v-if="item.textBoxType === 'input_more'">
      <el-input
        v-model="item.conditonVal"
        placeholder="请输入"
        clearable
        @change="changeInputMore(item)"
      ></el-input>
      <slot></slot>
    </template>
    <template v-if="item.textBoxType === 'month'">
      <!-- v-model="F_Data[item.conditonKey]" -->
      <el-date-picker
        prefix-icon="''"
        value-format="yyyy-MM"
        v-model="item.conditonVal"
        type="month"
        placeholder="选择月"
      >
      </el-date-picker>
      <slot></slot>
    </template>
    <template v-if="item.textBoxType === 'select'">
      <!-- v-model="F_Data[item.conditonKey]" -->

      <el-select
        v-model="item.conditonVal"
        clearable
        remote
        filterable
        :remote-method="
          (e) => {
            remoteMethod(e, item, index);
          }
        "
        @focus="
          (e) => {
            focusMethod(item, index);
          }
        "
        @clear="remoteMethod('', item, index)"
        :placeholder="item.conditonKeyShow"
        @change="changeSelector(item, index)"
      >
        <el-option
          v-for="(option, num) in item.selectOptions"
          :label="option[item.dropdownShowField]"
          :value="option[item.dropdownSubmitField]"
          :key="num"
        />
      </el-select>
      <slot></slot>
    </template>
    <template v-if="item.textBoxType === 'select_more'">
      <!-- v-model="F_Data[item.conditonKey]" -->

      <el-select
        v-model="item.conditonVal"
        clearable
        remote
        filterable
        multiple
        :remote-method="
          (e) => {
            remoteMethod(e, item, index);
          }
        "
        @focus="
          (e) => {
            focusMethod(item, index);
          }
        "
        @clear="remoteMethod('', item, index)"
        :placeholder="item.conditonKeyShow"
        @change="changeSelector(item, index)"
      >
        <el-option
          v-for="(option, num) in item.selectOptions"
          :label="option[item.dropdownShowField]"
          :value="option[item.dropdownSubmitField]"
          :key="num"
        />
      </el-select>
      <slot></slot>
    </template>
    <template v-if="item.textBoxType === 'select_object'">
      <el-select
        v-model="item.conditonVal"
        :disabled="
          item.conditonKey == 'objectName' && !F_config[index - 1].conditonVal
        "
        clearable
        remote
        filterable
        @visible-change="getList($event, item, index)"
        @change="changeObjVal($event, item, index)"
        :remote-method="
          (e) => {
            remoteMethodOBJ(e, item, index);
          }
        "
      >
        <el-option
          v-for="(option, num) in item.selectOptions"
          :label="option[item.dropdownShowField]"
          :value="option[item.dropdownSubmitField]"
          :key="num"
        />
      </el-select>
      <slot></slot>
    </template>
    <template v-if="item.textBoxType === 'datetime'">
      <multitime
        :timeType="item.timeType"
        :timeTypes="item.timeTypes"
        :startTime="item.startTime_a"
        :endTime="item.endTime_a"
        @timestatus="
          (type, s, e) => {
            timestatus(type, s, e, index);
          }
        "
        @queryBtn_ok="
          (s, e) => {
            queryBtn_time(s, e, index);
          }
        "
      ></multitime>
    </template>
    <template v-if="item.textBoxType === 'date'">
      <multitime
        :timeType="item.timeType"
        :timeTypes="item.timeTypes"
        :startTime="item.startTime_a"
        :endTime="item.endTime_a"
        @timestatus="
          (type, s, e) => {
            timestatus(type, s, e, index);
          }
        "
        @queryBtn_ok="
          (s, e) => {
            queryBtn_time(s, e, index);
          }
        "
      ></multitime>
    </template>
    <template v-if="item.textBoxType.includes('dept_tree')">
      <dept-tree
        v-model="item.conditonVal"
        :multiple="deptMultiple(item)"
        :checkStrictly="deptTreeCheckStrictly(item)"
        :is-storage="deptTreeIsStorage(item)"
        close-on-click-modal
      ></dept-tree>
    </template>
  </span>
</template>
<script>
import multitime from "@/components/multiTime.vue";
import DeptTree from "@/components/DeptTree.vue";
export default {
  components: { multitime, DeptTree },
  emits: ["changeCallback", "EnterClick"],
  props: {
    item: {},
    F_config: {},
    index: {},
  },
  methods: {
    deptMultiple(item) {
      if (item.textBoxType.includes("single")) {
        return false;
      }
      return true;
    },
    deptTreeCheckStrictly(item) {
      if (item.textBoxType.includes("single")) {
        return true;
      }
      if (item.textBoxType.includes("strict")) {
        return true;
      }
      return false;
    },
    deptTreeIsStorage(item){
      if(item.dropdownDefaultConditionField){
        if(item.dropdownDefaultConditionField === 'is_storage=1'){
          return 1
        }else{
          return 0
        }
      }
      return null
    },
    // 选择结算对象
    changeObjVal(val, item, index) {
      if (item.conditonKey == "objectStatusConfDictId") {
        let list = item.selectOptions || [];
        list.forEach((element) => {
          if (element.id == val) {
            this.F_config[index].key = element.key;
          }
        });
        if (!val) {
          this.F_config[index + 1].conditonVal = "";
        }
      }
    },
    // 获取结算对象/类型下拉列表
    async getList(e, item, index) {
      if (e) {
        let arrs = [
          {
            conditonKey: item.dropdownShowField,
            conditonVal: "",
          },
        ];
        if (item.conditonKey == "objectName") {
          // item.conditonKey == 'objectName' && !F_config[index-1].conditonVal
          arrs.push({
            conditonKey: "key",
            conditonVal: this.F_config[index - 1].key,
          });
        }
        await this.$API
          .runPageReport({
            conditionReqs: arrs,
            number: item.dropdownApiNumber,
            pageStart: 1,
            pageTotal: 9999,
          })
          .then((res) => {
            let datas = res.data.result.datas.data || [];
            this.F_config[index].selectOptions = datas;
          });
      }
    },

    // 多条件输入框，中间都隔开
    changeInputMore(item) {
      // if(!item.conditonVal_1){
      //   item.conditonVal = []
      //   return
      // }
      // item.conditonVal = item.conditonVal_1.split(',')
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e, index) {
      // this.F_config[index].startTime_a = `${s} 00:00:00` || "";
      // this.F_config[index].endTime_a = `${e} 23:59:59` || "";
      this.F_config[index].startTime_a = s || "";
      this.F_config[index].endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e, index) {
      this.F_config[index].timeType = type || "";
      // this.F_config[index].startTime_a = `${s} 00:00:00` || "";
      // this.F_config[index].endTime_a = `${e} 23:59:59` || "";
      this.F_config[index].startTime_a = s || "";
      this.F_config[index].endTime_a = e || "";
    },
    async focusMethod(item, index) {
      if (item.parent && item.parent.conditonVal !== item.parentFieldVal) {
        item.selectOptions = [];
        item.conditonVal = "";
      }
      if (!item.selectOptions || item.selectOptions.length == 0) {
        const conditions = [
          {
            conditonKey: item.dropdownShowField,
            conditonVal: "",
          },
        ];
        if (item.dropdownDefaultConditionField) {
          let dropdownDefaultSelectVal = item.dropdownDefaultSelectVal;
          if (
            dropdownDefaultSelectVal &&
            dropdownDefaultSelectVal.startsWith("condition.")
          ) {
            const parentField = dropdownDefaultSelectVal.substring(
              10,
              dropdownDefaultSelectVal.length
            );
            const parent = this.F_config.filter(
              (item) => item.conditonKey === parentField
            )[0];
            dropdownDefaultSelectVal = parent.conditonVal;
            item.parentFieldVal = dropdownDefaultSelectVal;
            item.parent = parent;
          }
          if (!dropdownDefaultSelectVal) {
            return;
          }
          conditions.push({
            conditonKey: item.dropdownDefaultConditionField,
            conditonVal: dropdownDefaultSelectVal,
          });
        }
        await this.$API
          .runPageReport({
            conditionReqs: conditions,
            number: item.dropdownApiNumber,
            pageStart: 1,
            pageTotal: 9999,
          })
          .then((res) => {
            let datas = res.data.result.datas.data || [];
            item.selectOptions = datas;
          });
      }
    },
    changeSelector(ee, index) {
      this.F_config.map((item) => {
        let dropdownDefaultSelectVal = item.dropdownDefaultSelectVal;
        if (
          dropdownDefaultSelectVal &&
          dropdownDefaultSelectVal.startsWith("condition.")
        ) {
          const parentField = dropdownDefaultSelectVal.substring(
            10,
            dropdownDefaultSelectVal.length
          );
          if (parentField === ee.conditonKey) {
            item.conditonVal = "";
            this.changeSelector(item);
          }
        }
      });
    },
    // 远程搜索
    async remoteMethod(e, item, index) {
      await this.$API
        .runPageReport({
          conditionReqs: [
            {
              conditonKey: item.dropdownShowField,
              conditonVal: e,
            },
          ],
          number: item.dropdownApiNumber,
          pageStart: 1,
          pageTotal: 9999,
        })
        .then((res) => {
          let datas = res.data.result.datas.data || [];
          item.selectOptions = datas;
        });
      this.$emit("changeCallback", e, name);
    },
    // 远程搜索(结算对象/类型)
    async remoteMethodOBJ(e, item, index) {
      if (item.conditonKey == "objectName") {
        let arrs = [
          {
            conditonKey: item.dropdownShowField,
            conditonVal: e,
          },
        ];
        if (item.conditonKey == "objectName") {
          arrs.push({
            conditonKey: "key",
            conditonVal: this.F_config[index - 1].key,
          });
        }
        await this.$API
          .runPageReport({
            conditionReqs: arrs,
            number: item.dropdownApiNumber,
            pageStart: 1,
            pageTotal: 9999,
          })
          .then((res) => {
            let datas = res.data.result.datas.data || [];
            item.selectOptions = datas;
          });
      }
    },
    // 滚动条加载更多
    loadmore(e) {
      this.$emit("changeCallback", "", e);
    },
    enterClick() {
      this.$emit("EnterClick");
    },
    after() {
      this.$emit("after");
    },
  },
};
</script>
<style lang="less">
.months {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }

  // .el-input__prefix {
  //   right: 5px !important;
  // }
}
</style>
<style scoped lang="less">
.group-field {
  .el-form-item {
    display: flex;
    width: auto;
  }
}
</style>